var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.204,
    height: 17.204,
    viewBox: "0 0 17.204 17.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0071f2;\n        stroke: #0071f2;\n        stroke-width: 0.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-clock",
    className: "cls-1",
    d: "M10.252,2A8.252,8.252,0,1,0,18.5,10.251,8.252,8.252,0,0,0,10.252,2Zm0,.718a7.529,7.529,0,1,1-5.33,2.205,7.535,7.535,0,0,1,5.33-2.205ZM10.246,3.79a.359.359,0,0,0-.353.364V9.238a1.073,1.073,0,0,0-.612,1.477L7.128,12.869a.359.359,0,1,0,.507.507l2.154-2.153a1.075,1.075,0,1,0,.822-1.984V4.153a.359.359,0,0,0-.364-.364Z",
    transform: "translate(-1.646 -1.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/timing.7632d546b5b38704125fababf5737884.svg";
export { ForwardRef as ReactComponent };